var _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    width: "78.222069mm",
    height: "78.221886mm",
    viewBox: "0 0 78.222069 78.221886",
    id: "svg854",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs851"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient961"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000000",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop957"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop959"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient961",
    id: "linearGradient963",
    x1: 0,
    y1: 147.6635,
    x2: 295.331,
    y2: 147.6635,
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-53.701474,-99.750844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g955",
    transform: "matrix(0.26506713,0,0,0.26506713,53.671238,99.72105)",
    style: {
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    d: "m 291.416,142.376 -33.14,-25.16 c -2.997,-2.275 -7.01,-2.661 -10.383,-0.98 -3.362,1.666 -5.492,5.101 -5.492,8.861 v 15.395 h -9.803 v -15.559 c 0,-5.465 -4.43,-9.896 -9.893,-9.896 H 203.009 V 78.294 c 0,-5.466 -4.431,-9.896 -9.894,-9.896 H 162.342 V 57.896 h 8.284 c 5.464,0 9.895,-4.431 9.895,-9.895 0,-5.464 -4.431,-9.893 -9.895,-9.893 h -63.92 c -5.463,0 -9.894,4.429 -9.894,9.893 0,5.464 4.431,9.895 9.894,9.895 h 8.29 v 10.502 h -38.25 c -5.464,0 -9.895,4.43 -9.895,9.896 V 97.607 H 47.528 c -5.465,0 -9.895,4.43 -9.895,9.894 v 22.634 H 19.787 v -28.073 c 0,-5.464 -4.43,-9.894 -9.894,-9.894 C 4.429,92.167 0,96.598 0,102.061 v 103.49 c 0,5.464 4.429,9.893 9.894,9.893 5.464,0 9.894,-4.43 9.894,-9.893 v -28.074 h 17.847 v 23.203 c 0,5.465 4.43,9.894 9.895,9.894 h 24.881 l 34.907,42.989 c 1.879,2.313 4.701,3.656 7.68,3.656 h 107.709 c 5.464,0 9.893,-4.432 9.893,-9.895 v -13.073 h 9.803 v 13.073 c 0,3.865 2.249,7.372 5.758,8.99 1.323,0.607 2.735,0.904 4.135,0.904 2.319,0 4.609,-0.816 6.441,-2.383 l 33.141,-28.404 c 2.193,-1.882 3.453,-4.625 3.453,-7.514 v -68.663 c -0.002,-3.09 -1.451,-6.008 -3.915,-7.878 z",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g904",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g906",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g908",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g910",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g912",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g914",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g916",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g918",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g920",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g922",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g924",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g926",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g928",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g930",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g932",
    style: {
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.bffb1d5bcf01b4c2539e17c06ea4cb50.svg";
export { ForwardRef as ReactComponent };